<script lang="ts">
export default {
    name: "FiltersComponent",
    props: {
        permissionName: { type: String, required: true },
        translationName: { type: String, required: true },
        tabsEnabled: { type: Array, required: false, default: () => [] },
        filters: { type: Array, required: true },
        loading: { type: Boolean, required: false },
        filtersOverload: { type: Array, required: false, default: () => [] },
        moreFiltersOverload: { type: Array, required: false, default: () => [] },
    },
    emits: ["resetPagination", "loadData"],
    data() {
        return {
            activeTab: "basic",
            moreOptionsPanel: false,
        }
    },
    computed: {
        query() { // COMPUTED NEEDED TO REFRESH EXPORTS BUTTONS
            return this.getQuery()
        },
    },
    methods: {
        getQuery() { // METHODS NEEDED CAUSE COMPUTED DOESNT ALWAYS REFRESH ON PARENT'S METHOD.
            const basic = this.$refs.basic?.query || {}
            const moreFilters = this.$refs.moreFilters?.query || {}
            return { ...moreFilters, ...basic }
        },
        resetFiltersInit() {
            this.$refs?.basic?.resetFilters()
            this.$refs?.moreFilters?.resetFilters()
            this.$emit("resetPagination")
            this.$emit("loadData")
        },
    },
}
</script>

<template>
    <div
        v-if="filters.length"
        class="filters mb-4"
    >
        <v-card class="py-2 px-5">
            <v-window
                v-model="activeTab"
                disabled
            >
                <v-window-item value="basic">
                    <ListOfflineFiltersBasic
                        ref="basic"
                        :loading
                        :filters-overload="moreOptionsPanel ? moreFiltersOverload : filtersOverload"
                        :filters
                        :translation-name
                        @reset-pagination="$emit('resetPagination')"
                        @load-data="$emit('loadData')"
                    >
                        <template v-if="filters.map(filter => filter.name).some(name => moreFiltersOverload.includes(name))">
                            <v-col
                                v-if="filters.map(filter => filter.name).some(name => moreFiltersOverload.includes(name))"
                                class="pa-2"
                                cols="12"
                                lg="3"
                                md="4"
                                sm="6"
                            >
                                <v-btn
                                    class="h-100 pa-4"
                                    color="primary"
                                    variant="tonal"
                                    block
                                    :append-icon="moreOptionsPanel ? 'mdi-minus' : 'mdi-plus'"
                                    :text="moreOptionsPanel ? 'Cacher les filtres' : 'Voir plus de filtres'"
                                    @click="moreOptionsPanel = !moreOptionsPanel"
                                />
                            </v-col>
                        </template>
                    </ListOfflineFiltersBasic>
                    <ListFiltersActions
                        :loading
                        @reset-filters="resetFiltersInit()"
                        @reset-pagination="$emit('resetPagination')"
                        @load-data="$emit('loadData')"
                    />
                </v-window-item>
                <!-- <v-window-item value="advance">
          <InfoCard text="En cours de développement" />
        </v-window-item>
        <v-window-item value="custom">
          <InfoCard text="En cours de développement" />
        </v-window-item>
      </v-window> -->
            </v-window>
        </v-card>
    </div>
</template>
